import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SEO from "../../config/SEO";
import { blogListUrl } from "../../utils/Universalfunctions";

const BlogDetail = () => {
     const { slug } = useParams();
     const [data, setData] = useState([]);
     const [loading, setLoading] = useState(true);

     useEffect(() => {
          setLoading(true);
          fetch(blogListUrl)
               .then((res) => res.json())
               .then((json) => {
                    setTimeout(() => {
                         setLoading(false);

                         setData(json);


                    }, 1000);
               })
               .catch(() => setLoading(false));
     }, [slug]); // slug change hone par re-fetch

     const post = data.find((p) => p.slug === slug);

     return (
          <>
                <SEO
                    title={post?.title}
                    description={post?.paragraph}
                    keywords={post?.category}
                    canonicalPath={`/blog/${post?.slug}`}
               />


               <div className="__heyprompt-blog">
                    <div className="__container">
                         <div className="row">
                              {loading ? (
                                   /* Skeleton Loader - Jab loading true ho */
                                   <div className="col-12">
                                        <div className="skeleton-wrapper-blogs">
                                             <div className="row">
                                                  <div className="col-md-7">
                                                       <div className="sk-breadcrumb"></div>
                                                       <div className="sk-title"></div>
                                                       <div className="sk-title short"></div>
                                                       <div className="sk-meta"></div>
                                                       <div className="sk-image"></div>
                                                       <div className="sk-text"></div>
                                                       <div className="sk-text"></div>
                                                       <div className="sk-text half"></div>
                                                  </div>
                                                  <div className="col-md-4 offset-md-1">
                                                       {[1, 2, 3].map((n) => (
                                                            <div key={n} className="sk-card">
                                                                 <div className="sk-card-title"></div>
                                                                 <div className="sk-card-meta"></div>
                                                                 <div className="sk-card-text"></div>
                                                                 <div className="sk-card-btn"></div>
                                                            </div>
                                                       ))}
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              ) : (

                                   <>
                                        <div className="col-md-7">
                                             <div className="blog-detail-page">
                                                  <nav aria-label="breadcrumb">
                                                       <ol className="breadcrumb">
                                                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                                            <li className="breadcrumb-item"><Link to="/blogs">Blog</Link></li>
                                                            <li className="breadcrumb-item active">{slug}</li>
                                                       </ol>
                                                  </nav>
                                                  <h1 className="detail-title">{post?.title}</h1>
                                                  <p className="detail-paragraph" dangerouslySetInnerHTML={{ __html: post?.paragraph }} />
                                                  <div className="detail-meta">
                                                       <span>{post?.category}</span> · <span>{post?.date}</span>
                                                  </div>
                                                  <div className="__txj3">
                                                       <div className="__area-img">
                                                            <img src={post?.image} alt={post?.title} className="detail-img" />
                                                       </div>
                                                       {[1, 2, 3, 4, 5, 6].map(i => post?.[`text${i}`] && 
                                                       <p key={i}  dangerouslySetInnerHTML={{ __html: post[`text${i}`]} }/>
                                                       )}
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="col-md-4 offset-md-1 in-phone-view">
                                             {data.slice(0, 4).map((item, i) => (
                                                  <div className="insdf-card" key={i}>
                                                       <div className="details-area">
                                                            <h3>{item?.title}</h3>
                                                            <span className="date">Update: {item?.date}</span>
                                                            <p>{item?.paragraph?.replace(/<[^>]*>/g, '').slice(0, 150)}...</p>
                                                            <Link to={`/blog/${item?.slug}`} className="link-arrow">Explore Full Blog ↗</Link>
                                                       </div>
                                                  </div>
                                             ))}
                                        </div>
                                   </>
                              )}
                         </div>
                    </div>
               </div>
          </>
     );
};

export default BlogDetail;